import React, { useState, useEffect } from 'react'
import Dropdown from 'react-bootstrap/Dropdown'
import { Pill } from 'src/components/Reusable/Pill'
import { CheckBoxInput } from 'src/components/Reusable/Inputs/CheckBox'
import { StyledDropdownToggle } from '../../StandardDropdown/StandardDropdown.styles'
import { FlexRow } from '../../Flex'
import { PlaceholderText } from '../Inputs.styles'

export interface TagInputProps {
  options: { name: string | JSX.Element; value: string }[]
  onChange?: (value: string[]) => void
  initialValue?: string[]
}

export const TagInput = ({
  options,
  onChange,
  initialValue,
}: TagInputProps): JSX.Element => {
  const [selectedTags, setSelectedTags] = useState<string[]>([])

  useEffect(() => {
    if (initialValue) {
      setSelectedTags(initialValue)
    }
  }, [initialValue])

  const handleSelect = (tag: string) => {
    let newTags: string[]
    if (selectedTags.includes(tag)) {
      newTags = selectedTags.filter((t) => t !== tag)
    } else {
      newTags = [...selectedTags, tag]
    }
    setSelectedTags(newTags)
    onChange?.(newTags)
  }

  const handleOnClose = (e: React.MouseEvent<HTMLDivElement>, tag: string) => {
    e.preventDefault()
    e.stopPropagation()
    const newTags = selectedTags.filter((t) => t !== tag)
    setSelectedTags(newTags)
    onChange?.(newTags)
  }

  const getValueName = (value: string) => {
    return options.find((option) => option.value === value)?.name
  }

  return (
    <Dropdown
      autoClose="outside"
      style={{
        width: '100%',
      }}
    >
      <Dropdown.Toggle
        as={StyledDropdownToggle}
        style={{
          height: '40px',
          width: '100%',
        }}
      >
        {selectedTags.length > 0 ? (
          <FlexRow gap={8}>
            {selectedTags.map((tag) => (
              <Pill
                key={tag}
                label={getValueName(tag)}
                backgroundColor="#FFFFFF"
                isCloseable
                onClose={(e) => handleOnClose(e, tag)}
                useBorder
              />
            ))}
          </FlexRow>
        ) : (
          <PlaceholderText>Select user</PlaceholderText>
        )}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {options.map((option) => (
          <Dropdown.Item
            key={option.value}
            onClick={() => handleSelect(option.value)}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                pointerEvents: 'none',
              }}
            >
              <CheckBoxInput
                checked={selectedTags.includes(option.value)}
                readOnly
                style={{ marginRight: '8px' }}
              />
              {option.name}
            </div>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}
